<template>
  <div>
    <div v-show="(comment_id!=0)">
      <strong>{{comment.created_by}}</strong>
      <span class="created_at"> - {{comment.created_at}}</span>&nbsp;&nbsp;<a  v-on:click="editmode" style="cursor:pointer" v-show="comment.edit&&!readonly"><em class="fas fa-pencil-alt" aria-hidden="true"></em></a>&nbsp;&nbsp;<a  v-on:click="confirmDeleteComment" style="cursor:pointer" v-show="comment.edit&&!readonly"><em class="fas fa-trash-alt" aria-hidden="true"></em></a><br>
      <span v-show="readmode_comment" v-html="comment.comment"></span>
    </div>
    <div v-show="(comment_id==0)" v-on:click="editmode">
      <input v-show="readmode_comment" class="form-control" placeholder="Ajouter un commentaire..." />
    </div>
    <span v-show="!readmode_comment">
      <trumbowyg :config="$trumbowygConfig" style="height:100px" class="form-control" v-model="commentedit"></trumbowyg>
      <label class="error" v-if="errors.commentedit">{{ errors.commentedit }}</label>
      <div style="margin-top:5px">
        <button type="button" class="btn btn-primary btn-sm" v-on:click="save_comment"><i class="fas fa-save" aria-hidden="true"></i> Enregistrer</button>
        <button type="button" class="btn btn-link btn-sm" v-on:click="cancelComment">Annuler</button>
      </div>
    </span>
    <br>
   
    <transition name="modal" >
      <div class="modal-mask" v-show="show_confirm_comment">
          <div class="modal-block modal-block">
            <section class="panel">
              <header class="panel-heading">
                  <strong>Êtes-vous certain?</strong>
              </header>
              <div class="panel-body">
                <div class="modal-wrapper">
                  <div class="modal-text">
                    <p>Êtes-vous certain de vouloir supprimer ce commentaire?</p>
                  </div>
                </div>
              </div>
              <footer class="panel-footer">
                <div class="row">
                  <div class="col-md-12 text-right">
                    <a class="btn btn-default" v-on:click="show_confirm_comment=false">Non</a>&nbsp;&nbsp;<a class="btn btn-default" v-on:click="delete_comment">Oui</a>
                  </div>
                </div>
              </footer>
            </section>
          </div>
      </div>
    </transition>
  </div>
</div>
</template>
<style>
.created_at {
  color: #999;
  font-size: 85%;
}
</style>

<script>

import axios from 'axios';

export default {
  name: 'Comment',
  props: ['parent_id','parent_class','comment_id','readonly'],

  data: function() {return {
    show_confirm_comment:false,
    readmode_comment:true,
    comment:{},
    commentedit:'',
    oldcomment:'',
    errors:{comment:'',commentedit:''},
  }},

  methods:
  {

    refresh: function() {
      if(this.comment_id>0){
      axios
        .get(this.$root.$data.server_base + '/api/comment.php',
          { params: {parent_id:this.parent_id,parent_class: this.parent_class,comment_id: this.comment_id}})
        .then(response => (
          this.comment = response.data.comment,
          this.commentedit = this.comment.comment
          ))
      }
    },
    editmode: function()
    {
      if(this.comment_id>0)
        this.commentedit = this.comment.comment;
      else
        this.commentedit = '';
      this.readmode_comment=false;

    },
   
    cancelComment: function()
    {
      if(this.comment_id>0)
        this.commentedit = this.comment.comment;
      else
        this.commentedit = '';

      this.readmode_comment=true;

    },

    confirmDeleteComment: function()
    {
     
      this.show_confirm_comment = true;

    },

    save_comment: function()
    {
      var empty_field = false;

      if(this.commentedit == '')
      {
        this.errors.commentedit = this.messages.required;
        empty_field = true;
      }
      else
        this.errors.commentedit = '';

      if(!empty_field)
      {
        let data = {
          parent_class:this.parent_class,
          parent_id:this.parent_id,
          comment_id:this.comment_id,
          comment:this.commentedit
        };

        axios
          .post(this.$root.$data.server_base + '/api/comment_save.php',
            data,
            {headers:{
                'Content-Type': 'application/json',
            }})
          .then(() => (this.readmode_comment=true,this.refresh(),this.$parent.refresh()))
      }
    },
    
    delete_comment: function()
    {

      let data = {
          comment_id:this.comment_id,
          delete:true
      };


      axios
        .post(this.$root.$data.server_base + '/api/comment_save.php',
          data,
            {headers:{
                'Content-Type': 'application/json',
            }})
        .then(() => (this.show_confirm_comment=false,this.$parent.refresh()))
    },

  },
  mounted () {
    this.messages = this.$root.$data.messages;
    this.refresh();
  },
  

}
</script>
